import EventEmitter from 'src/helpers/EventEmitter'
import { DEG_TO_RAD } from 'src/helpers/MathUtils'
import Touch from '@/helpers/Touch'
import Raf from '@/helpers/Raf'
import store from '@/store';
import ImageService from '@/services/ImageService'
 
import RingBufferGeometry from 'src/components/Stage/question/RingBufferGeometry'
import ResizeService from '@/services/ResizeService' 
const THREE = require('three')
 
class Timer extends THREE.Group { 

  constructor(config) {

    super();

    Object.assign(this, EventEmitter);

    this.position.z = 0;
    this.touch = new Touch(window);
    this.rotation.z = 90 * DEG_TO_RAD;
    this.STATES = store.state.question.STATES;

    this.tweenObj = {
      opacity: 0
    } 

    var geometry = new RingBufferGeometry( 50, 70,  30, 0, Math.PI * 2); 
    var texture = this.createTexture(require('@/assets/img/timer.png')); 
    let material = new THREE.MeshBasicMaterial({
      map: texture,
      transparent: true,
      opacity: 0
    })
    var mesh = new THREE.Mesh( geometry, material ); 
    mesh.scale.x = mesh.scale.y = 1;//0.01; 
    this.add( mesh );
  }

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img);   
    texture.needsUpdate = true;
    return texture;
  }

  updateRoute(val) {
    switch(val.name) { 
      case 'question':
        Raf.add(this.onTick)
        break; 
      default:
        Raf.remove(this.onTick)
    }
  } 

  updateState(val) {
    switch(val) {
      case this.STATES.IDLE:
        this.idle();
        break;
      case this.STATES.TAP_HOLD_PROGRESS:
        this.tapholdProgress();
        break;
      case this.STATES.TAP_HOLD_RECORD:
        this.tapholdRecord();
        break; 
      case this.STATES.TAP_HOLD_RELEASE:
        this.tapholdRelease();
        break; 
      case this.STATES.PROCESSING:
        this.processing();
        break; 
      case this.STATES.COMPLETE:
        this.complete();
        break;
      case this.STATES.ERROR:
        this.error();
        break;
    }
    this.state = val; 
  }

  idle() { }

  tapholdProgress() {  }
  
  tapholdRecord() { 
    TweenMax.to(this.tweenObj, 0.6, {
      opacity: 1 
    });
    this.visible = true;
  }

  tapholdRelease() {
    TweenMax.to(this.tweenObj, 0.6, {
      opacity: 0
    });
  }
    
  processing() {
    TweenMax.to(this.tweenObj, 0.6, {
      opacity: 0
    });
    this.visible = false;
  }
    
  complete() {}

  result(val){}
 
 
  onTick = () => { 

    this.position.x = this.touch.x * window.innerWidth;
    this.position.y = this.touch.y * -window.innerHeight;

    let s = store.state.question;
    if(s.state === s.STATES.TAP_HOLD_RECORD){ 
      let child = this.children[0];  
      child.geometry.dispose(); // dispose our old geometry 
      child.material.opacity = this.tweenObj.opacity; // dispose our old geometry  
      let geometry = new RingBufferGeometry(50, 70, 32, null, 0, Math.PI * 2 * s.timer_ratio); // build a new 
      child.geometry = geometry; // apply the new one
    }
  }
   
  resize = () => {}
 
 
}

export default Timer